export class LiquidHttpRequestError extends Error {

  constructor(response, content) {

    const message =
      content?.message ||
      response?.statusText ||
      'Erro inesperado na requisição.';

    super(message);

    this.name = 'LiquidHttpRequestError';

    this.httpStatusCode = response?.status;
    this.httpStatusText = response?.statusText;

    this.apiErrorCode = content?.errorCode;
    this.content = content;
  }

}